// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__3t088","content":"Layout_content__2Ka1Y","mobileLogo":"Layout_mobileLogo__3UQyY","authenticated":"Layout_authenticated__3BV-S"};